import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPUsr"; // Adjust to match your backend API

const ADPUsrService = {
    async findAll(facilityCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`, { params: { facilityCode } });
        return response.data;
    },

    async getItemById(userId: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${userId}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(userId: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${userId}`, item);
        return response.data;
    },

    async delete(userId: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${userId}`);
        return response.data;
    },

    async uploadImage(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/upload-image`, item);
        return response.data;
    },

    async getItemByIcNo(icNo: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one-by-ic-no/${icNo}`);
        return response.data;
    },
    
    async getDropdownList(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown`);
        return response.data;
    },

    async checkPassword(userId: any, currentPassword: any, newPassword:any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/check-password/${userId}/${currentPassword}/${newPassword}`);
        return response.data;
    },

    async changeTenant(userId: any,selectFacilityCode: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/change-tenant/${userId}/${selectFacilityCode}`);
        return response.data;
    },

};

export default ADPUsrService;